import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {ServiceType} from "@shared/Quote/ServiceType";
import {QuoteSectionId} from "@shared/Quote/QuoteSectionId";

export function getPlannedSessionServiceItems(quoteItem) {
	return (quoteItem?.getAllServiceItems?.() || []).filter(item =>
		item.serviceType === ServiceType.SESSION && item.sectionId === QuoteSectionId.DIRECT_WORK)
}

export function buildSessionCountBySourceServiceId(journalEntries = []) {
	let counts = {}
	for (let entry of journalEntries) {
		if (entry?.type !== JournalEntryType.SESSION || !entry.sourceServiceId) continue
		counts[entry.sourceServiceId] = (counts[entry.sourceServiceId] || 0) + 1
	}
	return counts
}

export function createTlswPlanSessionCountMap(sessionCountMap = null) {
	return {...sessionCountMap}
}

export function buildTlswPlanSessionCountMapFromJournalEntries(journalEntries = []) {
	return buildSessionCountBySourceServiceId(journalEntries)
}

export function applyTlswPlanSessionCountDelta(sessionCountMap = null, journalEntries = [], delta = 0) {
	let nextCounts = createTlswPlanSessionCountMap(sessionCountMap)
	for (let entry of journalEntries) {
		if (entry?.type !== JournalEntryType.SESSION || !entry.sourceServiceId) continue
		let key = entry.sourceServiceId
		nextCounts[key] = Math.max(0, (Number(nextCounts[key]) || 0) + delta)
	}
	return nextCounts
}

export function getTlswSessionPlanMismatches({
	quoteItem = null,
	journalEntries = [],
	sessionCountMap = null,
	sourceContextLabel = "quote",
} = {}) {
	let counts = sessionCountMap || buildSessionCountBySourceServiceId(journalEntries)
	return getPlannedSessionServiceItems(quoteItem).flatMap(item => {
		let quoteCount = Math.max(0, Number(item.quantityNumber) || 0)
		let planCount = Math.max(0, Number(counts[item.id]) || 0)
		if (quoteCount === planCount) return []
		let difference = quoteCount - planCount
		let sessionLabel = item.title || "Sessions"
		let instructionText = difference > 0
			? `Plan is missing ${difference} ${difference === 1 ? "session" : "sessions"} for ${sessionLabel}. Add them below or update the ${sourceContextLabel}.`
			: `Plan has ${Math.abs(difference)} extra ${Math.abs(difference) === 1 ? "session" : "sessions"} for ${sessionLabel}. Remove them below or update the ${sourceContextLabel}.`
		return [{sourceServiceId: item.id, sessionLabel, quoteCount, planCount, instructionText}]
	})
}

export function hasTlswSessionPlanMismatches(options = {}) {
	return getTlswSessionPlanMismatches(options).length > 0
}
